module.exports = __webpack_public_path__ + "static/img/shoutao.2cb3d29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shoutao.png
// module id = S+2l
// module chunks = 21